<template>
    <rednax-datatable
        :url="'/vue/cardorders/list'"
        :columns="table_columns"
        :filter="table_filter"
        v-on="customerId > 0 || cardSeriesId > 0 ? { rowclick: rowClick } : { rowclick: rowClick, updateFilter }"
        :per-page="10"
        sort-by="OrderID"
        sort-order="desc"
        size="sm"
        ref="tblcardorder"
        :no-wrapper="noWrapper"
    >
        <template v-if="!noWrapper" #header>
            <h6 class="card-title"><i class="icon-cart5 mr-2"></i>Ordrar</h6>
        </template>
        <form @submit.prevent="formSubmit" v-if="!(customerId > 0 || cardSeriesId > 0 || productId > 0)">
            <div class="row">
                <div class="col-lg-3">
                    <div class="form-group">
                        <input type="text" class="form-control" v-model="table_filter.search" placeholder="Sök...">
                    </div>
                </div>
                <div class="col-lg-3">
                    <v-select
                        v-model="table_filter.source"
                        :options="sources"
                        :reduce="s => s.id"
                        label="label"
                        placeholder="-- Alla Källor --"
                    ></v-select>
                </div>
                <div class="col-lg-3">
                    <v-select
                        v-model="table_filter.status_id"
                        :options="select_statuses"
                        :reduce="s => s.id"
                        label="label"
                        placeholder="Ej levererade ordrar"
                        :selectable="s => s.selectable"
                    ></v-select>
                </div>
<!--                        <div class="col-lg-2">-->
<!--                            <v-select-->
<!--                                v-model="table_filter.seller_id"-->
<!--                                :options="users"-->
<!--                                :reduce="u => u.UserID"-->
<!--                                label="FullName"-->
<!--                                placeholder="&#45;&#45; Alla Säljare &#45;&#45;"-->
<!--                            ></v-select>-->
<!--                        </div>-->
            </div>
            <div class="row">
                <div class="col-lg-6">
                    <v-date-picker
                        v-model="date"
                        mode="date"
                        :locale="{ id: 'sv', firstDayOfWeek: 2, masks: { weekdays: 'WW', input: 'YYYY-MM-DD' } }"
                        :model-config="{ type: 'string', mask: 'YYYY-MM-DD' }"
                        is-range
                        show-iso-weeknumbers
                        :popover="{ visibility: 'focus'}"
                    >
                        <template v-slot="{ inputValue, inputEvents }">
                            <div class="row">
                                <div class="col" style="position:relative;">
                                    <div class="input-group">
                                        <span class="input-group-prepend">
                                            <span class="input-group-text">
                                                <i class="icon-calendar2"></i>
                                            </span>
                                        </span>
                                        <input
                                            class="form-control"
                                            :value="inputValue.start"
                                            v-on="inputEvents.start"
                                        />
                                        <span class="input-group-append">
                                            <button type="button" class="btn btn-light" @click="clearDate">
                                                <i class="icon-cross3"></i>
                                            </button>
                                        </span>
                                    </div>
                                </div>
                                <div class="flex-shrink-1 d-flex justify-content-center align-items-center">
                                    <i class="icon-arrow-right8"></i>
                                </div>
                                <div class="col" style="position:relative;">
                                    <div class="input-group">
                                        <span class="input-group-prepend">
                                            <span class="input-group-text">
                                                <i class="icon-calendar2"></i>
                                            </span>
                                        </span>
                                        <input
                                            class="form-control"
                                            :value="inputValue.end"
                                            v-on="inputEvents.end"
                                        />
                                        <span class="input-group-append">
                                            <button type="button" class="btn btn-light" @click="clearDate">
                                                <i class="icon-cross3"></i>
                                            </button>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </v-date-picker>
                </div>
                <div class="col-lg-6 text-right">
                    <button class="btn btn-primary" type="submit">Sök</button>
                </div>
            </div>
        </form>

        <template #cell_PaymentStatusID="{ row }">
            <span class="badge" :class="['badge-' + (payment_statuses[row.PaymentStatusID] ? payment_statuses[row.PaymentStatusID].color : 'secondary')]">
                {{ payment_statuses[row.PaymentStatusID] ? payment_statuses[row.PaymentStatusID].label : row.PaymentStatusID }}
            </span>
        </template>
        <template #cell_DeliveryStatusID="{ row }">
            <span class="badge" :class="['badge-' + (delivery_statuses[row.DeliveryStatusID] ? delivery_statuses[row.DeliveryStatusID].color : 'secondary')]">
                {{ delivery_statuses[row.DeliveryStatusID] ? delivery_statuses[row.DeliveryStatusID].label : row.DeliveryStatusID }}
            </span>
        </template>
        <template #cell_StatusID="{ row }">
            <span class="badge" :class="['badge-' + (order_statuses[row.StatusID] ? order_statuses[row.StatusID].color : 'secondary')]">
                {{ (order_statuses[row.StatusID] ? order_statuses[row.StatusID].label : row.StatusID) }}
            </span>
<!--            <limitless-button-->
<!--                :ref="'btnsetstatus' + row.OrderID" v-if="parseInt(row.CardAmountTotal, 10) === parseInt(row.CardAmountActivated, 10) && row.StatusID < 500"-->
<!--                btn-class="btn-light px-1"-->
<!--                style="width: 64px;"-->
<!--                @click="setCardOrderStatus(row.OrderID, 500, $event)"-->
<!--            >Sätt klar</limitless-button>-->
        </template>
    </rednax-datatable>
</template>

<script>
import RednaxDatatable from '@components/Datatable/RednaxDatatableComponent';
import apiClient from '@services/ApiClient';
import vSelect from 'vue-select';
import VDatePicker from 'v-calendar/lib/components/date-picker.umd';
import BackendRepository from '@services/repositories/BackendRepository';
import UserRepository from '@services/repositories/UserRepository';
import { formatCurrency } from '@services/Helpers';
import { keyBy } from 'lodash';

export default {
    name: 'OrderList',
    components: {
        RednaxDatatable,
        vSelect,
        VDatePicker,
    },
    props: {
        customerId: {
            type: Number,
            default: null,
        },
        cardSeriesId: {
            type: Number,
            default: null,
        },
        productId: {
            type: Number,
            default: null,
        },
        noWrapper: {
            type: Boolean,
            default: false,
        },
    },
    data: () => ({
        date: {
            start: '',
            end: '',
        },
        table_filter: {
            search: '',
            seller_id: null,
            date_start: null,
            date_end: null,
            source: null,
            status_id: null,
            customer_id: null,
            product_id: null,
            card_series_id: null,
        },
        sources: [
            {
                id: 'manual',
                label: 'Intranät',
            },
            {
                id: 'portal',
                label: 'Kundportal/API',
            },
            {
                id: 'web',
                label: 'supekort.se',
            },
            {
                id: 'other',
                label: 'Övriga',
            },
        ],
        users: [],
        order_statuses: [],
        delivery_statuses: [],
        payment_statuses: [],
    }),
    created() {
        if (this.customerId > 0) {
            this.table_filter.customer_id = this.customerId;
            this.table_filter.status_id = 'all';
        }
        if (this.cardSeriesId > 0) {
            this.table_filter.card_series_id = this.cardSeriesId;
            this.table_filter.status_id = 'all';
        }
        if (this.productId > 0) {
            this.table_filter.product_id = this.productId;
            this.table_filter.status_id = 'all';
        }
    },
    mounted() {
        this.getStatuses();
        this.getSellers();
    },
    watch: {
        'table_filter.search': function localFilterSearch(val) {
            if (val) {
                this.table_filter.status_id = 'all';
            }
        },
        date: {
            deep: true,
            handler(date) {
                if (date.start) {
                    this.table_filter.date_start = date.start;
                } else {
                    this.table_filter.date_start = '';
                }
                if (date.end) {
                    this.table_filter.date_end = date.end;
                } else {
                    this.table_filter.date_end = '';
                }
            },
        },
    },
    methods: {
        rowClick(row, event) {
            if (event.metaKey === true || event.ctrlKey === true) {
                window.open('/cardorders/' + row.OrderID).focus();
            } else {
                this.$router.push({ name: 'cardorders.edit', params: { id: row.OrderID } });
            }
        },
        formSubmit() {
            this.$refs.tblcardorder.reload();
        },
        updateFilter(emittedFilter) {
            const filter = { ...emittedFilter };
            if (!filter.StatusID && filter.search) {
                filter.StatusID = 'all';
            }
            Object.keys(this.table_filter).forEach((key) => {
                if (filter[key] !== undefined) {
                    this.table_filter[key] = filter[key];
                }
            });
            this.date = {
                start: filter.date_start,
                end: filter.date_end,
            };
        },
        clearDate() {
            this.date.start = null;
            this.date.end = null;
        },
        getStatuses() {
            BackendRepository.getCardOrderPaymentStatuses().then((res) => {
                this.payment_statuses = keyBy(res, 'id');
            });
            BackendRepository.getCardOrderDeliveryStatuses().then((res) => {
                this.delivery_statuses = keyBy(res, 'id');
            });
            BackendRepository.getCardOrderOrderStatuses().then((res) => {
                this.order_statuses = keyBy(res, 'id');
            });
        },
        getSellers() {
            const repo = new UserRepository();
            repo.getSellers().then((res) => {
                this.users = res;
            });
        },
        async setCardOrderStatus(orderId, statusId) {
            let doChange = false;
            await this.$swal({
                text: 'Är du säker att du vill ändra status till "LEVERERAD"?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Ja, ändra!',
                cancelButtonText: 'Avbryt',
            }).then((result) => {
                if (result.isConfirmed) {
                    doChange = true;
                }
            });

            if (doChange) {
                await apiClient.post('/vue/cardorders/' + orderId, { card_order: { StatusID: statusId } })
                    .then(() => {
                        this.$refs.tblcardorder.reload();
                    }).catch(() => {
                        this.$refs['btnsetstatus' + orderId].triggerFailed();
                    });
            }
        },
    },
    computed: {
        table_columns() {
            const arr = [];

            arr.push({
                header: '#',
                data: 'OrderID',
                sortable: true,
                render(row) {
                    return '<div><a href="/cardorders/' + row.OrderID + '">' + row.OrderID + '</a></div>';
                },
            });
            arr.push({
                header: 'Datum',
                data: 'CreatedTS',
                sortable: true,
                render(row) {
                    return '<nobr>' + row.CreatedTS.substring(0, 10) + '</nobr>';
                },
            });
            // if (this.customerId > 0) {
            //     arr.push({
            //         header: 'Mottagare',
            //         data: 'DelivCompany',
            //         sortable: true,
            //         render(row) {
            //             return row.DelivCompany + (row.EndCustomer ? ' / ' + row.EndCustomer : '');
            //         },
            //     });
            // } else {
            arr.push({
                header: 'Kundgrupp',
                data: 'CustomerGroupName',
                sortable: true,
            });
            arr.push({
                header: 'Kund',
                data: 'CompanyName',
                sortable: true,
                render(row) {
                    return row.CompanyName + (row.EndCustomer ? ' / ' + row.EndCustomer : '');
                },
            });
            // }
            arr.push({
                header: 'Epost',
                data: 'CustomerContactMail',
                sortable: true,
            });
            arr.push({
                header: 'Kund Ordernr',
                data: 'CustomerRefNo',
                sortable: true,
            });
            // if (!(this.customerId > 0)) {
            //     arr.push({
            //         header: 'Leverans',
            //         data: 'DelivCompany',
            //         sortable: true,
            //     });
            // }
            if (this.productId > 0) {
                arr.push({
                    header: 'Antal produkter',
                    data: 'ProductTotal',
                    sortable: true,
                    align_right: true,
                    render(row) {
                        return row.ProductTotal + ' st';
                    },
                });
            } else {
                if (this.cardSeriesId > 0) {
                    arr.push({
                        header: 'Antal kort',
                        data: 'CardTotal',
                        sortable: true,
                        align_right: true,
                        render(row) {
                            return row.CardTotal + ' st';
                        },
                    });
                } else {
                    arr.push({
                        header: 'Antal kort',
                        data: 'CardAmountTotal',
                        sortable: true,
                        align_right: true,
                        render(row) {
                            return row.CardAmountTotal + ' st';
                        },
                    });
                }
                arr.push({
                    header: 'Antal Aktiverade',
                    data: 'CardAmountActivated',
                    sortable: true,
                    align_right: true,
                    render(row) {
                        return row.CardAmountActivated + ' st';
                    },
                });
            }
            arr.push({
                header: 'Källa',
                data: 'CreatedSource',
                sortable: false,
                render(row) {
                    if (row.CreatedSource === 'intranet') {
                        return 'Intranät';
                    }
                    if (row.CreatedSource === 'SUPEKORT_SE_TWILL_V3' || row.CreatedSource === 'SUPEKORT_SE_STATAMIC_V2' || row.CreatedSource === 'SUPEKORT_SE_STATAMIC' || row.CreatedSource === 'supekort.se') {
                        return 'supekort.se';
                    }
                    if (row.CreatedSource === 'Custom Order webAPI' || row.CreatedSource === 'Interstellar API') {
                        return 'Kundportal/API';
                    }
                    return row.CreatedSource;
                },
            });
            arr.push({
                header: 'Ordervärde',
                data: 'OrderSum',
                sortable: true,
                align_right: true,
                render(row) {
                    return formatCurrency(row.OrderSum, 2, row.CurrencyShort);
                },
            });
            arr.push({
                header: 'Orderstatus',
                data: 'StatusID',
                sortable: true,
            });
            arr.push({
                header: 'Leveransstatus',
                data: 'DeliveryStatusID',
                sortable: true,
            });
            arr.push({
                header: 'Betalstatus',
                data: 'PaymentStatusID',
                sortable: true,
            });

            return arr;
        },
        old_system_url() {
            return window.config.app.old_system_url;
        },
        select_statuses() {
            const arr = [];
            arr.push({ id: 'all', label: 'ALLA ORDRAR', selectable: true });
            arr.push({ id: '---', label: '------------', selectable: false });

            Object.values(this.order_statuses).forEach((status) => {
                arr.push({ id: status.id, label: status.label, selectable: true });
            });

            return arr;
        },
    },
};

</script>
